<style scoped>
.ipt-sty {
  width: 70% !important;
}
.title-box {
  display: flex;
  align-items: center;
  padding-left: 50px;
}
.title-box-name span {
  color: red;
}
.config-box {
  padding: 0 40px 0 20px;
}
.config-box .config-list {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.config-list-label span {
  color: red;
}
.config-list-label {
  flex-shrink: 0;
  width: 90px;
  text-align: right;
}
.config-week-box {
  display: flex;
  align-items: center;
}
.config-week-box span {
  margin: 0 10px;
}
/* 部门 */
.select-box {
  overflow: hidden;
  margin: 0 0px 10px 30px;
}
.box-left {
  width: 40%;
  height: 350px;
  padding: 0 20px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
  overflow-y: auto;
}
.box-right {
  width: 57%;
  height: 350px;
  padding: 0 10px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
}
.field-radio {
  display: flex;
  align-items: center;
}
.field-radio .el-form-item__content {
  margin-left: 0 !important;
}
.other-config{
  display: flex;
  font-size: 14px;
  padding-left: 50px;
  padding-top: 30px;
}
.other-content{
  flex: 1;
}
.other-content-list{
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.other-title{
  padding-right: 30px;
}
.place-choose {
  color: #4fa1a4;
  text-decoration: underline;
  cursor: pointer;
}
.place-show {
  padding-left: 10px;
  padding-right: 20px;
  cursor: pointer;
}
</style>
<template>
  <div class="content" v-loading.fullscreen.lock="fullscreenLoading">
    <div class="search-area">
      <el-row :gutter="24">
        <el-col :span="9"
          ><div class="search-area-div">报告名称：</div>
          <el-input v-model="page.reportName" class="ipt-sty" placeholder="请输入" :clearable="true"></el-input
        ></el-col>
        <el-col :span="9"
          ><div class="search-area-div">任务状态：</div>
          <el-select v-model="page.reportState" placeholder="请选择" class="ipt-sty">
            <el-option v-for="item in taskOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <el-button size="medium" type="info" @click="getData(true)">搜索</el-button>
          <el-button size="medium" type="danger" @click="empty">清空</el-button>
        </el-col>
      </el-row>
    </div>
    <div class="button-area">
      <el-button icon="el-icon-plus" size="medium" type="info" @click="add(1, '')">新增报告通知</el-button>
      <!-- <el-button size="medium" type="danger" @click="getDeleteData(1, '')">批量删除</el-button> -->
    </div>
    <div class="back-color-fff" style="padding: 16px">
      <el-table :data="tableData" style="width: 100%; margin-bottom: 20px" border v-loading="loading">
        <el-table-column label="序号" width="60" header-align="center" align="center" fixed="left">
          <template slot-scope="scope">
            {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        <!-- <el-table-column type="selection" width="60" header-align="center" align="center"></el-table-column> -->
        <el-table-column prop="reportName" label="报告名称" header-align="center" align="left"> </el-table-column>
        <el-table-column prop="notificationType" label="报告类型" header-align="center" align="center">
          <template slot-scope="scope">
            {{ getType(scope.row.notificationType) }}
          </template>
        </el-table-column>
        <el-table-column prop="manufacturerName" label="药企名称" header-align="center" align="left"> </el-table-column>
        <el-table-column prop="notifyPeriod" label="生成周期" header-align="center" align="center">
          <template slot-scope="scope">{{ scope.row.notifyPeriod | notifyPeriod }}</template>
        </el-table-column>
        <el-table-column prop="notifyPeriod" label="周期范围" header-align="center" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.notifyPeriod == 'W'"
              >{{ getWeekStart(scope.row.weekGenerateDateEnd) }}~{{ scope.row.weekGenerateDateEnd }}</span
            >
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="remindTime" label="提醒时间(时)" header-align="center" align="center"> </el-table-column>
        <el-table-column prop="noticeTotal" label="通知人员" header-align="center" align="right"></el-table-column>
        <el-table-column prop="updateTime" label="更新时间" sortable header-align="center" align="center">
          <template slot-scope="scope">{{ scope.row.createTime | getDate }}</template>
        </el-table-column>
        <el-table-column label="操作" header-align="center" align="left" width="200">
          <template slot-scope="scope">
            <div v-if="scope.row.reportState == 'P'">
              <a class="txt-color" @click="add(2, scope.row)">撤回 | </a>
              <a class="txt-color" @click="add(5, scope.row)">统计报表</a>
            </div>
            <div v-else>
              <a class="txt-color" @click="add(3, scope.row)">编辑 | </a>
              <a class="txt-color" @click="add(4, scope.row)">发布 | </a>
              <a class="txt-color-red" @click="getDeleteData(2, scope.row.guid)">删除</a>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      class="pt pb back-color-fff"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 100, 200]"
      :current-page="page.pageIndex"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.totalRows"
    >
    </el-pagination>
    <!-- 推送机制 -->
    <el-dialog title="推送机制" :visible.sync="dialogVisibleConfig" width="600px" :close-on-click-modal="false">
      <div class="config-box">
        <div class="config-list">
          <div class="config-list-label"><span>*</span>报告名称：</div>
          <el-input type="text" v-model="ruleForm.reportName" placeholder="质量审核周报/行为档案周报"></el-input>
        </div>
        <div class="config-list">
          <div class="config-list-label"><span>*</span>报告类型：</div>
          <el-select v-model="ruleForm.notificationType" placeholder="请选择" class="w100f">
            <el-option v-for="item in noticeTypeOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="config-list">
          <div class="config-list-label"><span>*</span>生成周期：</div>
          <el-select v-model="ruleForm.notifyPeriod" placeholder="请选择" class="w100f">
            <el-option v-for="item in cycleOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <!-- 生成周期为月 -->
        <div class="config-list" v-if="ruleForm.notifyPeriod == 'M'">
          <div class="config-list-label"><span>*</span>周期时间：</div>
          <el-select v-model="ruleForm.monthGenerateType" placeholder="请选择" class="w100f">
            <el-option v-for="item in monthOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <!-- 生成周期为周 -->
        <div class="config-list" v-if="ruleForm.notifyPeriod == 'W'">
          <div class="config-list-label"><span>*</span>周期时间：</div>
          <div class="config-week-box">
            <el-select v-model="weekDate" @change="weekStartChange" placeholder="请选择" class="w35f">
              <el-option v-for="item in weekOption" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
            <span>至</span>
            <el-select v-model="ruleForm.weekGenerateDateEnd" @change="weekEndChange" placeholder="请选择" class="w35f">
              <el-option v-for="item in weekOption" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="config-list">
          <div class="config-list-label"><span>*</span>提醒时间：</div>
          <el-time-select
            
            :picker-options="{
              start: '00:00',
              step: '01:00',
              end: '23:00',
            }"
            v-model="ruleForm.remindTime"
            placeholder="请选择"
          >
          </el-time-select>
        </div>
        <div class="config-list">
          <div class="config-list-label"><span>*</span>药企名称：</div>
          <el-select
            v-model="ruleForm.manufacturerGuid"
            placeholder="请选择"
            class="w100f"
            filterable
            @change="handleChangeCompany"
          >
            <el-option
              v-for="item in tenantList"
              :key="item.sendTenantGuid"
              :label="item.sendTenantName"
              :value="item.sendTenantGuid"
            >
            </el-option>
          </el-select>
        </div>
        <div class="config-list">
          <div class="config-list-label"><span>*</span>通知对象：</div>
          <span v-if="departmentList.length == 0" class="place-choose" @click="chooseObject">请选择</span>
          <span class="place-show" @click="chooseObject" v-else>{{ getDeliverName(departmentList) }} </span>
          <!-- <el-select
            v-model="ruleForm.organisationGuids"
            filterable
            multiple
            collapse-tags
            placeholder="请选择"
            class="w100f"
          >
            <el-option
              v-for="item in organisationList"
              :key="item.guid"
              :label="item.organisationName"
              :value="item.guid"
            ></el-option>
          </el-select> -->
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button plain size="medium" @click="dialogVisibleConfig = false">取 消</el-button>
        <el-button size="medium" type="info" @click="submitForm()">提 交</el-button>
      </div>
    </el-dialog>
    <!-- 查看统计报表 -->
    <el-dialog title="查看统计报表" :visible.sync="dialogVisibleTotal" width="750px">
      <el-table :data="tatalTable" style="width: 100%" v-loading="totalLoading">
        <el-table-column label="序号" width="60" header-align="center" align="center">
          <template slot-scope="scope">
            {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="生成时间" header-align="center" align="center">
          <template slot-scope="scope">{{ scope.row.createTime | getDate }}</template>
        </el-table-column>
        <el-table-column prop="noticeTotal" label="通知人数" header-align="center" align="right"></el-table-column>
        <el-table-column prop="readNum" label="查阅人数" header-align="center" align="right"></el-table-column>
      </el-table>
      <el-pagination
        class="pt pb back-color-fff"
        background
        @size-change="handleSizeChangeTotal"
        @current-change="handleCurrentChangeTotal"
        :page-sizes="[10, 50, 100]"
        :current-page="pageTotal.pageIndex"
        :page-size="pageTotal.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageTotal.totalRows"
      >
      </el-pagination>
    </el-dialog>
    <!-- 选择部门 -->
    <el-dialog title="选择部门" :visible.sync="visible3" width="70%" center>
      <div>
        <div class="select-box">
          <div class="box-left fl">
            <el-input v-model="filterText" class="ipt-sty mt15" placeholder="请输入部门名称"></el-input>
            <p class="fontC-bbb">组织架构</p>
            <el-tree
              class="filter-tree"
              :data="areaData"
              :props="defaultProps"
              :filter-node-method="filterNode"
              @check="handleNodeClick1"
              :check-strictly="true"
              show-checkbox
              ref="tree"
              node-key="guid"
              v-if="visible3"
              :default-checked-keys='organisationGuids'
            >
            </el-tree>
          </div>
          <div class="box-right fr">
            <p class="fontC-bbb fl">已选{{ departmentList.length }}个部门</p>
            <el-button size="medium" type="danger" @click="delDepartment()" class="fr" style="margin-top: 5px"
              >批量删除</el-button
            >
            <el-table
              :data="departmentList"
              border
              height="280px"
              style="width: 100%"
              @selection-change="handleSelectionChange1"
            >
              <el-table-column type="selection" width="55"> </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                show-overflow-tooltip
                prop="organisationName"
                label="名称"
              >
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer t-right">
        <el-button plain size="medium" @click="visible3 = false">取消</el-button>
        <el-button size="medium" type="info" @click="departmentSure()">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialogVisibleTotal: false,
      dialogVisibleConfig: false,
      ruleForm: {
        guid: null,
        reportName: '',
        notificationType: '', //通知类型
        notifyPeriod: '', //生成周期
        remindTime: '',
        weekGenerateDateEnd: '',
        monthGenerateType: '', //月报类型
        tenantGuid: '',
        organisationGuids: [],
        manufacturerGuid: '',
      },
      weekDate: '',
      taskOptions: [
        { label: '未发布', value: 'C' },
        { label: '发布', value: 'P' },
      ],
      tenantList: [],
      organisationGuids: [],
      noticeTypeOptions: [],
      cycleOptions: [
        { label: '日', value: 'D' },
        { label: '周', value: 'W' },
        { label: '月', value: 'M' },
        { label: '年', value: 'Y' },
      ],
      monthOptions: [
        { label: '自然月', value: '1' },
        { label: '核算月', value: '2' },
      ],
      weekOption: [
        { label: '周一', value: '1' },
        { label: '周二', value: '2' },
        { label: '周三', value: '3' },
        { label: '周四', value: '4' },
        { label: '周五', value: '5' },
        { label: '周六', value: '6' },
        { label: '周日', value: '7' },
      ],
      textTitle: '',
      page: {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        tenantGuid: '',
        reportState: '', //报告通知状态（P 发布；C 撤回）
        reportName: '',
      },
      pageTotal:{
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        tenantGuid: '',
        reportNotificationGuid: '', 
      },
      loading: false,
      fullscreenLoading: false,
      totalLoading:false,
      tableData: [],
      tatalTable: [],
      multipleSelection: [],
      //部门
      visible3: false,
      area: [],
      departmentList: [],
      departmentData: '',
      organisationNameList: '',
      areaData: [],
      delList: [],
      filterText: '',
      defaultProps: {
        id: 'guid',
        label: 'organisationName',
        children: 'children',
        disabled: this.disabledTreeNode,
      },
    };
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },
  created() {
    // 列表
    this.getData(false);
    this.getTenant();
    this.getNotificationType();
  },
  methods: {
    //报告类型
    getType(val) {
      let name = '-';
      if (this.noticeTypeOptions.length > 0) {
        this.noticeTypeOptions.forEach((i) => {
          if (val == i.value) {
            name = i.label;
          }
        });
      }
      return name;
    },
    getDeliverName(res) {
      var list = res;
      let newList = [];
      list.forEach((item) => {
        newList.push(item.organisationName);
      });
      if(newList.length>1){
        return newList[0]+'、'+newList[1]+'等'+newList.length+'个执行部门';
      }else{
        return newList.join('、');
      }
    },
    isContainOrg(arr, guid) {
      if (!arr.length) return 0;
      let flag = arr.findIndex((one) => {
        return one == guid;
      });
      if (flag == -1) {
        return 0;
      } else {
        return 1;
      }
    },
    disabledTreeNode(data, node) {
      let list = this.departmentList;
      if (list.length) {
        let flag = 0;
        let parentGuids = data.parentGuids ? data.parentGuids : [];
        for (let i = 0; i < list.length; i++) {
          let checkedParentGuids = list[i].parentGuids ? list[i].parentGuids : [];
          if (this.isContainOrg(parentGuids, list[i].guid)) {
            flag = 1;
            break;
          } else if (this.isContainOrg(checkedParentGuids, data.guid)) {
            flag = 1;
            break;
          } else {
            flag = 0;
          }
        }
        return flag > 0;
      } else {
        return false;
      }
    },
    //获取公司
    getTenant() {
      let self = this;
      let query = {
        isService: true,
        tenantGuid: localStorage.guid,
      };
      self.api
        .get(`/${serverConfig.msCustomerService}/tenant/data/get-tenant-operation-rel-list`, query)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.tenantList = res.data.data;
            // self.ruleForm.tenantGuid = self.tenantList[0].sendTenantGuid;
            self.getData(false);
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    //获取组织
    handleChangeCompany(v, type) {
      let self = this;
      let query = {
        pageIndex: 1,
        pageSize: -1,
        tenantGuid: v,
      };
      if (type !== 1) {
        self.ruleForm.organisationGuids = [];
        this.area = [];
        this.departmentList = [];
        this.departmentData = [];
        this.areaData = [];
        this.delList = [];
        this.filterText = '';
      }
      self.api.get(`/${serverConfig.msPersonnelService}/organisation/data/get-organisation-detail?bizState=Y&tenantGuid=${v}`).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.areaData = res.data.data;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    chooseObject(){
      if(!this.ruleForm.manufacturerGuid){
        this.$message.error('请先选择药企名称')
        return
      }
      this.visible3 = true;
    },
    getWeekStart(val) {
      let name = '-';
      let newVal = '';
      this.weekOption.forEach((i) => {
        if (val == i.label) {
          newVal = i.value;
        }
      });
      if (newVal == '1') {
        newVal = '7';
      } else if(newVal == '7'){
        newVal = '1';
      } else{
        newVal = (Number(newVal) + 1).toString();
      }
      this.weekOption.forEach((j) => {
        if (newVal == j.value) {
          name = j.label;
        }
      });
      return name;
    },
    weekStartChange(val) {
      if (val == '7') {
        this.ruleForm.weekGenerateDateEnd = '1';
      } else if(val == '1'){
        this.ruleForm.weekGenerateDateEnd = '7';
      } else{
        this.ruleForm.weekGenerateDateEnd = (Number(val) - 1).toString();
      }
    },
    weekEndChange(val) {
      if (val == '1') {
        this.weekDate = '7';
      } else if(val == '7'){
        this.weekDate = '1';
      } else{
        this.weekDate = (Number(val) + 1).toString();
      }
    },
    //通知类型
    getNotificationType() {
      let that = this;
      that.api
        .get(
          `/${serverConfig.msConfigureService}/sysparameter/data/get-detail-grp?tenantGuid=${localStorage.guid}&code=YYBG_BGLX`,
        )
        .then((res) => {
          if (res.data.msg == 'success') {
            if (res.data.data && res.data.data.length > 0) {
              res.data.data.forEach((i) => {
                let item = {
                  label: i.name,
                  value: i.parameterValue,
                };
                this.noticeTypeOptions.push(item);
              });
            }
            // this.contractYearList = res.data.data;
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    empty() {
      let self = this;
      self.page = {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        tenantGuid: '',
        bizType: '调研对象',
        // tenantName: '',
        paramName: '',
      };
      self.getData(true);
    },
    getData(flg) {
      let self = this;
      if (flg) {
        self.page.pageIndex = 1;
      }
      self.loading = true;
      self.tableData = [];
      self.page.tenantGuid = localStorage.guid;
      self.api
        .postJson(`/${serverConfig.msSalesPerformService}/report_push/data/get-report-notification`, self.page)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.loading = false;
            self.tableData = res.data.data.records;
            self.page.totalPage = res.data.data.totalPages;
            self.page.totalRows = res.data.data.totalRows;
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    // 统计
    getTotal(flg) {
      let self = this;
      if (flg) {
        self.pageTotal.pageIndex = 1;
      }
      self.totalLoading = true;
      self.tatalTable = [];
      // self.pageTotal.tenantGuid = localStorage.guid;
      self.api
        .postJson(`/${serverConfig.msSalesPerformService}/report_push/data/get-report-weekly-history`, self.pageTotal)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.totalLoading = false;
            self.tatalTable = res.data.data.records;
            self.pageTotal.totalPage = res.data.data.totalPages;
            self.pageTotal.totalRows = res.data.data.totalRows;
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    add(flg, row) {
      //(flg: 1 新增  2撤回  3编辑  4发布 5统计报表)
      let self = this;
      if (flg == 1) {
        self.textTitle = '新增报告通知';
        self.ruleForm = {
          guid: null,
          reportName: '',
          notificationType: '', //通知类型
          notifyPeriod: '', //生成周期
          remindTime: '',
          weekGenerateDateEnd: '',
          monthGenerateType: '', //月报类型
          tenantGuid: '',
          organisationGuids: [],
          manufacturerGuid: '',
        };
        this.weekDate = '';
        self.dialogVisibleConfig = true;
        this.area = [];
        this.departmentList = [];
        this.departmentData = [];
        this.areaData = [];
        this.delList = [];
        this.filterText = '';
      } else if (flg == 3) {
        self.textTitle = '编辑报告通知';
        self.fullscreenLoading = true;
        self.api
          .get(
            `/${serverConfig.msSalesPerformService}/report_push/data/get-report-notification-detail?guid=${row.guid}`,
          )
          .then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.fullscreenLoading = false;
              let data = res.data.data;
              self.ruleForm.guid = data.guid;
              self.ruleForm.reportName = data.reportName;
              self.ruleForm.notificationType = data.notificationType.toString();
              self.ruleForm.notifyPeriod = data.notifyPeriod;
              self.ruleForm.remindTime = data.remindTime;
              // self.ruleForm.weekGenerateDateEnd = data.weekGenerateDateEnd;
              self.ruleForm.monthGenerateType = data.monthGenerateType;
              self.ruleForm.tenantGuid = data.tenantGuid;
              self.ruleForm.manufacturerGuid = data.manufacturerGuid;
              this.weekOption.forEach((i) => {
                if (self.ruleForm.notifyPeriod == 'W' && data.weekGenerateDateEnd == i.label) {
                  self.ruleForm.weekGenerateDateEnd = i.label;
                  self.weekEndChange(i.value);
                }
              });
              self.departmentList = [];
              let organisationGuids = data.organisationGuids || [];
              organisationGuids.forEach((item, index) => {
                self.departmentList.push({
                  guid: item.organisationGuid,
                  organisationName: item.organisationName,
                });
                self.organisationGuids.push(item.guid)
              });
              self.departmentSure(true);
              // self.getOrganisation(self.tenantGuid);
              self.handleChangeCompany(self.ruleForm.manufacturerGuid, 1);
            } else {
              self.$message.error(res.data.msg);
            }
          });
        self.dialogVisibleConfig = true;
      } else if (flg == 2) {
        this.$confirm('此操作将撤回报告, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            self.api
              .postJson(`/${serverConfig.msSalesPerformService}/report_push/data/cancel?guid=${row.guid}`)
              .then((res) => {
                if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                  self.$message.success('撤回成功');
                  self.getData(true);
                } else {
                  self.$message.error(res.data.msg);
                }
              });
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消操作',
            });
          });
      } else if (flg == 4) {
        this.$confirm('确定发布, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            self.api
              .postJson(`/${serverConfig.msSalesPerformService}/report_push/data/publish?guid=${row.guid}`)
              .then((res) => {
                if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                  self.$message.success('发布成功');
                  self.getData(true);
                } else {
                  self.$message.error(res.data.msg);
                }
              });
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消操作',
            });
          });
      } else {
        this.dialogVisibleTotal = true;
        this.pageTotal.tenantGuid = row.manufacturerGuid ;
        this.pageTotal.reportNotificationGuid = row.guid ;
        self.getTotal(1)
      }
    },
    submitForm() {
      let self = this;
      if (!self.ruleForm.reportName) {
        self.$message.error('报告名称不能为空！');
        return;
      }
      if (!self.ruleForm.notificationType) {
        self.$message.error('通知类型不能为空！');
        return;
      }
      if (!self.ruleForm.notifyPeriod) {
        self.$message.error('生成周期不能为空！');
        return;
      }
      if (self.ruleForm.notifyPeriod == 'M' && !self.ruleForm.monthGenerateType) {
        self.$message.error('月份类型不能为空！');
        return;
      }
      if (self.ruleForm.notifyPeriod == 'W' && !self.ruleForm.weekGenerateDateEnd) {
        self.$message.error('周期时间不能为空！');
        return;
      }
      if (!self.ruleForm.remindTime) {
        self.$message.error('提醒时间不能为空！');
        return;
      }
      if (!self.ruleForm.manufacturerGuid) {
        self.$message.error('药企名称不能为空！');
        return;
      }
      if (!self.departmentList.length) {
        self.$message.error('通知对象不能为空！');
        return;
      }
      self.ruleForm.organisationGuids = [];
      console.log(self.departmentList)
      self.departmentList.forEach((item) => {
        let obj = {
          organisationName:item.organisationName,
          organisationGuid:item.guid
        }
        self.ruleForm.organisationGuids.push(obj);
        // organisationName.push(item.organisationName);
      });
      let resultData = JSON.parse(JSON.stringify(this.ruleForm));
      this.weekOption.forEach((i) => {
        if (self.ruleForm.notifyPeriod == 'W' && self.ruleForm.weekGenerateDateEnd == i.value) {
          resultData.weekGenerateDateEnd = i.label;
        }
      });
      self.fullscreenLoading = true;
      resultData.tenantGuid = localStorage.guid;
      if (resultData.guid) {
        self.api.put(`/${serverConfig.msSalesPerformService}/report_push/data/update`, resultData).then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.fullscreenLoading = false;
            self.dialogVisibleConfig = false;
            self.$message.success('修改成功');
            self.getData(true);
          } else {
            self.$message.error(res.data.msg);
          }
        });
      } else {
        self.api.postJson(`/${serverConfig.msSalesPerformService}/report_push/data/add`, resultData).then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.fullscreenLoading = false;
            self.dialogVisibleConfig = false;
            self.$message.success('新增成功');
            self.getData(true);
          } else {
            self.$message.error(res.data.msg);
          }
        });
      }
    },
    handleSelectionChange(val) {
      let self = this;
      self.multipleSelection = [];
      val.forEach(function (item) {
        //item 就是当日按循环到的对象
        self.multipleSelection.push(item.guid);
      });
    },
    getDeleteData(flg, guid) {
      let self = this;
      if (flg == 1) {
        if (self.multipleSelection.length == 0) {
          self.$message.error('请勾选数据！');
          return;
        }
      } else {
        self.multipleSelection = [];
        self.multipleSelection.push(guid);
      }
      this.$confirm('此操作将永久删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          self.api
            .postJson(`/${serverConfig.msSalesPerformService}/report_push/data/delete`, self.multipleSelection)
            .then((res) => {
              if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                self.multipleSelection = [];
                self.$message.success('删除成功');
                self.getData(true);
              } else {
                self.$message.error(res.data.msg);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
        });
    },
    //部门弹框选择
    handleNodeClick1(data) {
      this.departmentList = this.$refs.tree.getCheckedNodes(false);

      this.$forceUpdate();
    },
    //确定选择部门
    departmentSure(flag) {
      this.visible3 = false;
      let organisationNameList = [];
      if (this.departmentList.length == 0&&!flag) {
        this.$message.error('请选择部门');
        return;
      }
      this.departmentList.forEach((item) => {
        organisationNameList.push(item.organisationName);
      });
      this.organisationNameList = organisationNameList.join('、');
    },
    handleSelectionChange1(val) {
      let self = this;
      self.delList = val;
    },
    //删除部门
    delDepartment() {
      let self = this;
      if (self.delList == null || self.delList.length == 0) {
        self.$message.error('请勾选部门！');
        return;
      }
      self.delList.forEach(function (j) {
        self.departmentList.forEach(function (i, index) {
          if (i.guid == j.guid) {
            self.departmentList.splice(index, 1);
          }
        });
      });
      self.delList.forEach(function (m) {
        self.area.forEach(function (n, idn) {
          if (JSON.parse(n).guid == m.guid) {
            self.area.splice(idn, 1);
          }
        });
      });
    },
    //删除单个部门
    delDepartmentSingle(index) {
      this.departmentData.splice(index, 1);
      this.departmentList = this.departmentData;
      this.area.splice(index, 1);
      // this.departmentList.splice(index,1)
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.organisationName.indexOf(value) !== -1;
    },
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getData();
    },
    handleSizeChangeTotal(val) {
      let self = this;
      self.pageTotal.pageSize = val;
      this.getTotal();
    },
    handleCurrentChangeTotal(val) {
      let self = this;
      self.pageTotal.pageIndex = val;
      this.getTotal();
    },
  },
};
</script>
